<div class="header">
    <div class="buttonBack" (click)="onClickBack($event)">
        <i class="fa fa-arrow-left" aria-hidden="true"></i>
        <i class="fa fa-times" aria-hidden="true"></i>
    </div>
    <shared-active-slots-item-header [route]="selectedRoute"> </shared-active-slots-item-header>
    <button-link variant="back" class="line left" (linkClick)="goToNormal()" *ngIf="optionExpanded">{{
        'SHARED.ACTIVE.SLOTS.ITEM.DRIVERPLATE.BACK.CAPTION' | translate}}</button-link>
    <actions *ngIf="!readonly" [actionstrip]="actions" (clickAction)="onClickAction($event)"></actions>
</div>
<div #scrollContainer *ngIf="selectedRoute" class="desplegable">
    <div *ngIf="selectedRoute.isDivided" class="banner-divided-grouped-broken">
        <div class="icona"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div>
        <div class="texte">
            {{ 'SHARED.ROUTE.ITEM.BANNER.ISDIVIDED.CAPTION' | translate }}
        </div>

    </div>
    <div *ngIf="selectedRoute.isChildOfGrouped" class="banner-divided-grouped-broken"
        [innerHTML]="'SHARED.ROUTE.ITEM.BANNER.ISCHILDOFGROUPED.CAPTION' | translate:{ agrupationURI: agrupationURI}">
    </div>
    <div *ngIf="selectedRoute.isBrokenForTrucking" class="banner-divided-grouped-broken">
        <div class="icona"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div>
        <div class="texte">
            {{ 'SHARED.ROUTE.ITEM.BANNER.ISBROKENFORTRUCKING.CAPTION' | translate }}
        </div>
    </div>
    <div *ngIf="selectedRoute.isTrucked && !selectedRoute.truckingConfirmed" class="banner-truckingpendingconfirmed">
        <div class="icona"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div>
        <div class="texte">
            {{ 'SHARED.ROUTE.ITEM.BANNER.ISTRUCKEDCONFIRMEDPENDING.CAPTION' | translate }}
        </div>
    </div>
    <!--Cos principal, quan no hi ha res seleccionat-->
    <ng-container *ngIf="optionExpanded=='' || optionExpanded==null">
        <div class="block withcontrolat"
            [ngClass]="{'carrierName': selectedRoute.showAskCarrierName, 'carrierLegalIdentification': selectedRoute.showAskCarrierLegalIdentification, 'carrierAddress': selectedRoute.showAskCarrierAddress }"
            *ngIf="optionExpanded == ''">
            <div class="block"
                *ngIf="!selectedRoute.isChildOfGrouped && !selectedRoute.isDivided && !selectedRoute.isBrokenForTrucking">
                <shared-active-slots-item-driverplate [route]="selectedRoute" (refresh)="getData()"
                    [readonly]="readonly" [hideLink]="true">
                </shared-active-slots-item-driverplate>
                <button-link *ngIf="canAssignDriverAndPlates" variant="forward" class="line right important desktopslotreservegrotesque"
                    (linkClick)="onClickLinkOption('driverPlate')">{{
                    'SHARED.ACTIVE.SLOTS.ITEM.DRIVERPLATE.FORWARD.CAPTION'
                    | translate}}</button-link>
                <button-link *ngIf="showAssignDriverAndPlates" variant="action" class="line right"
                    (linkClick)="sendToDriver()">{{ 'SHARED.ACTIVE.SLOTS.ITEM.SENDTODRIVER.ACTION.CAPTION' |
                    translate}}</button-link>

            </div>
            <div class="block"
                *ngIf="!selectedRoute.isChildOfGrouped && !selectedRoute.isDivided && !selectedRoute.isBrokenForTrucking">
                <div class="titolslot">
                    {{'SHARED.SLOT.PICKER.SLOTS.CAPTION'| translate}}
                    <button-link class="" (linkClick)="switchPhases()"><span *ngIf="!showAllPhases">{{
                            'SHARED.ACTIVE.SLOTS.ITEM.SHOWALLPHASES' | translate}}</span><span *ngIf="showAllPhases">{{
                            'SHARED.ACTIVE.SLOTS.ITEM.SHOWSLOTPHASES' | translate}}</span></button-link>
                </div>
                <div class="item only-multiple">
                    <div class="item" *ngFor="let phase of getPhases() | sortBy:'executionOrder'">
                        <shared-active-slots-item-phase [@fadeInOut] [phase]="phase" (refreshRoute)="getData()"
                            (phaseDocumentation)="onPhaseDocumentation($event)" (phaseSignatureCMR)="onPhaseSignatureCMR($event)" class="no-help showMarker" [hideLink]="true">
                        </shared-active-slots-item-phase>
                        <button-link
                            *ngIf="!readonly && phase.requiresSlot && !phase.isSlotBlocked && !isCanceled(phase)"
                            class="line link right link-exwork important desktopslotreservegrotesque" (click)="onPhaseSlot(phase)">{{
                            'SHARED.ACTIVE.SLOTS.ITEM.PHASESLOT.FORWARD.CAPTION' |
                            translate}}</button-link>
                        <button-link *ngIf="!readonly && phase.canChangeStrongAddress && !isCanceled(phase)"
                            class="line link right link-exwork" (click)="onPhaseForcedStrongAddress(phase)">{{
                            'SHARED.ACTIVE.SLOTS.ITEM.PHASEFORCEDSTRONGADDRESS.FORWARD.CAPTION' |
                            translate}}</button-link>

                        <button-link *ngIf="!readonly && !isCanceled(phase)" class="line link right link-exwork"
                            (click)="onPhaseSignatureCMR(phase)">{{
                            'SHARED.ACTIVE.SLOTS.ITEM.PHASESIGNATURECMR.FORWARD.CAPTION' |
                            translate}}</button-link>

                        <button-link variant="forward" class="line right" (linkClick)="onPhaseLinks(phase)">{{
                            'SHARED.ACTIVE.SLOTS.ITEM.PHASELINKS.FORWARD.CAPTION' | translate}}</button-link>
                    </div>
                </div>
            </div>
            <button-link variant="forward" class="line left"
                *ngIf="selectedRoute.isChildOfGrouped && selectedRoute.routeParentGroupId > 0"
                (linkClick)="onGoParentGrouped()">{{ 'SHARED.ROUTE.ITEM.GOPARENTGROUPED.FORWARD.CAPTION' |
                translate}}
                <helppoint helptext="{{'SHARED.ROUTE.ITEM.GOPARENTGROUPED.FORWARD.HELP' | translate}}"></helppoint>
            </button-link>
            <button-link variant="forward" class="line left" *ngIf="selectedRoute.isGrouped"
                (linkClick)="onClickLinkOption('routesGroupShipment')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.ROUTESGROPSHIPMENT.FORWARD.CAPTION' | translate}}
                <helppoint helptext="{{'SHARED.ACTIVE.SLOTS.ITEM.ROUTESGROPSHIPMENT.FORWARD.HELP' | translate}}">
                </helppoint>
            </button-link>
            <button-link variant="forward" class="line left" *ngIf="selectedRoute.canGrouping"
                (linkClick)="onClickLinkOption('routesGrouping')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.ROUTESGROPING.FORWARD.CAPTION' | translate}}
                <helppoint helptext="{{'SHARED.ACTIVE.SLOTS.ITEM.ROUTESGROPING.FORWARD.HELP' | translate}}">
                </helppoint>
            </button-link>
            <button-link variant="forward" class="line left" *ngIf="selectedRoute.canDivided"
                (linkClick)="onClickLinkOption('routesDivided')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.ROUTESDIVIDED.FORWARD.CAPTION' | translate}}
                <helppoint helptext="{{'SHARED.ACTIVE.SLOTS.ITEM.ROUTESDIVIDED.FORWARD.HELP' | translate}}">
                </helppoint>
            </button-link>

            <button-link variant="forward" class="line left" (linkClick)="onClickLinkOption('partners')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.PARTNERS.FORWARD.CAPTION' | translate}}
                <helppoint helptext="{{'SHARED.ACTIVE.SLOTS.ITEM.PARTNERS.FORWARD.HELP' | translate}}">
                </helppoint>
            </button-link>

            <button-link variant="forward" class="line left" (linkClick)="onClickLinkOption('routeLog')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.ROUTELOG.FORWARD.CAPTION' | translate}}</button-link>

            <button-link variant="forward" class="line left" (linkClick)="onClickLinkOption('routeChat')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.ROUTECHAT.FORWARD.CAPTION' | translate}}</button-link>

            <button-link variant="forward" class="line left" (linkClick)="onClickLinkOption('shipmentsInRoute')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.SHIPMENTSINROUTE.FORWARD.CAPTION' | translate}}</button-link>
            <button-link variant="forward" class="line left" (linkClick)="onClickLinkOption('packagesInRoute')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.PACKAGESINROUTE.FORWARD.CAPTION' | translate}}</button-link>
            <button-link variant="forward" class="line left" (linkClick)="onClickLinkOption('modifyBanner')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.MODIFYBANNER.FORWARD.CAPTION' | translate}}</button-link>
            <button-link variant="forward" class="line left" (linkClick)="onClickLinkOption('changeStatus')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.CHANGESTATUS.FORWARD.CAPTION' | translate}}</button-link>
            <button-link variant="forward" class="line left" *ngIf="selectedRoute.canChangeConditions"
                (linkClick)="onClickLinkOption('changeConditions')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.CHANGECONDITIONS.FORWARD.CAPTION' | translate}}</button-link>

            <button-link variant="forward" class="line left" *ngIf="selectedRoute.canPhasesChangeDates"
                (click)="onClickLinkOption('phasesChangeDates')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.PHASESCHANGEDATES.FORWARD.CAPTION' | translate}}</button-link>

            <button-link variant="forward" class="line left" *ngIf="selectedRoute.canShowCMR"
                (linkClick)="onClickLinkOption('cmr')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.CMR.FORWARD.CAPTION' | translate}}</button-link>
            <button-link variant="forward" class="line left" (linkClick)="onClickLinkOption('documentaryreview')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.DOCUMENTARYREVIEW.FORWARD.CAPTION' | translate}}</button-link>


            <button-link variant="forward" class="line left" (linkClick)="onClickLinkOption('changeStatus')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.CHANGESTATUS.FORWARD.CAPTION' | translate}}</button-link>
            <button-link variant="forward" class="line left" (linkClick)="onClickLinkOption('modifyBanner')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.MODIFYBANNER.FORWARD.CAPTION' | translate}}</button-link>
            <button-link variant="forward" class="line left" (linkClick)="onClickLinkOption('changeTags')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.CHANGETAGS.FORWARD.CAPTION' | translate}}</button-link>
            <button-link variant="forward" class="line left" (linkClick)="onClickLinkOption('editAdditionalData')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.EDITADDITIONALDATA.FORWARD.CAPTION' | translate}}</button-link>
            <button-link variant="forward" class="line left" (linkClick)="onClickLinkOption('times')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.TIMES.CAPTION' | translate}}</button-link>

            <button-link variant="forward" class="line left" *ngIf="selectedRoute.canChangeBooking"
                (linkClick)="onClickLinkOption('booking')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.BOOKING.FORWARD.CAPTION' | translate}}</button-link>
            <button-link variant="forward" class="line left" (linkClick)="onClickLinkOption('properties')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.ROUTEPROPERTY.FORWARD.CAPTION' | translate}}</button-link>
            <button-link variant="forward" class="line left" (linkClick)="onClickLinkOption('changeMarks')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.CHANGEMARKS.FORWARD.CAPTION' | translate}}</button-link>
            <button-link variant="forward" class="line left" (linkClick)="onClickLinkOption('links')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.LINKS.FORWARD.CAPTION' | translate}}</button-link>

            <button-link variant="forward" *ngIf="selectedRoute.canTreeChart" class="line left"
                (linkClick)="onClickLinkOption('treeChart')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.TREECHART.FORWARD.CAPTION' | translate}}</button-link>

            <button-link variant="forward" class="line left"
                (linkClick)="onClickLinkOption('routeMap')">{{'SHARED.ACTIVE.SLOTS.ITEM.ROUTEMAP.FORWARD.CAPTION' |
                translate}}</button-link>
            <button-link variant="forward" class="line left" (linkClick)="onClickLinkOption('routeTelemetry')">{{
                'SHARED.ACTIVE.SLOTS.ITEM.ROUTETELEMETRY.FORWARD.CAPTION' | translate}}</button-link>

        </div>
    </ng-container>

    <div class="detall" *ngIf="optionExpanded == 'driverPlate'">
        <shared-active-slots-item-driverplate class="no-help no-btn-close" [route]="selectedRoute"
            (refresh)="goToNormal()" [readonly]="readonly" [autoEdit]="true"></shared-active-slots-item-driverplate>
    </div>

    <div class="detall active-slots-item-partners" *ngIf="optionExpanded == 'partners'">
        <shared-route-partner-selector [routeId]="routeId" class="component no-exwork" [showhelp]="true"
            [readonly]="readonly" (valueChanged)="getData()"></shared-route-partner-selector>

    </div>


    <div class="detall" *ngIf="optionExpanded == 'phaseSlot'">
        <shared-active-slots-item-phase [avoidPropertyPendingResponse]="avoidPropertyPendingResponse"
            [phase]="phaseSelected" (refreshRoute)="goToNormal()" class="no-help" [hideLink]="true"
            [autoGetSlots]="true">
        </shared-active-slots-item-phase>
    </div>
    <div class="detall" *ngIf="optionExpanded == 'forcedStrongAddress'">
        <shared-phase-change-strongaddress [phase]="phaseSelected" (valueChanged)="goToNormal()"
            class="component activeslots">
        </shared-phase-change-strongaddress>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'phaseSignatureCMR'">
        <shared-phase-cmr class="component activeslots" [phase]="phaseSelected">
        </shared-phase-cmr>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'routesGrouping'">
        <shared-route-group [routeId]="routeId" (finish)="onFinishRouteGroup($event)">
        </shared-route-group>
    </div>


    <div class="detall" *ngIf="optionExpanded == 'routesDivided'">
        <shared-route-divided [routeId]="routeId" (finish)="onFinishRouteGroup($event)">
        </shared-route-divided>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'routesGroupShipment'">
        <shared-route-group-child-list-component [routeId]="routeId"></shared-route-group-child-list-component>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'routeLog'">
        <shared-route-item-log-maintenance [routeId]="routeId">
        </shared-route-item-log-maintenance>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'routeChat'">
        <shared-chat class="suau no-participants" [notes]="true"
            [forcedOwnerParticipant]="routeChatForcedOwnerParticipant">
        </shared-chat>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'routeTelemetry'">
        <shared-telemetry class="fullheight reduced" [model]="'Route'" [modelId]="routeId"></shared-telemetry>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'routeMap'">
        <shared-map-route class="active-slots" [routeId]="routeId">
        </shared-map-route>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'phasesChangeDates'">
        <shared-phase-changedates-component [routeId]="routeId" class="component">
        </shared-phase-changedates-component>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'shipmentsInRoute'">
        <shared-route-shipment-order [routeId]="routeId"
            [readonly]="readonly || !selectedRoute.canReorderShipmentInRoute" class="component activeslots">
        </shared-route-shipment-order>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'packagesInRoute'">
        <shared-route-package-order [routeId]="routeId" [readonly]="readonly || !selectedRoute.canReorderPackageInRoute"
            class="component activeslots">
        </shared-route-package-order>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'modifyBanner'">
        <shared-banners [routeId]="routeId" class="component">
        </shared-banners>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'changeStatus'">
        <shared-route-changestatus [routeId]="routeId" [fromActiveRoutes]="false" class="component">
        </shared-route-changestatus>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'changeConditions'">
        <shared-route-changeconditions [routeId]="routeId" [fromActiveRoutes]="false" class="component">
        </shared-route-changeconditions>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'changeTags'">
        <shared-route-changetags [routeId]="routeId" class="component" [showtitle]="true" [readonly]="readonly"
            (valueChange)="getData()">
        </shared-route-changetags>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'editAdditionalData'">
        <shared-route-item-edit-additionaldata [route]="selectedRoute" class="component" [showtitle]="true"
            [readonly]="readonly" (valueChange)="getData()">
        </shared-route-item-edit-additionaldata>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'times'">
        <shared-statustime-component [routeId]="routeId" class="component">
        </shared-statustime-component>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'cmr'">
        <shared-active-slots-item-cmr [routeId]="routeId" [readonly]="readonly">
        </shared-active-slots-item-cmr>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'booking'">
        <shared-route-booking [routeId]="routeId" [readonly]="readonly">
        </shared-route-booking>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'documentaryreview'">
        <shared-documentaryreview-route-item [routeId]="routeId" [readonly]="readonly">
        </shared-documentaryreview-route-item>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'properties'">
        <shared-route-properties class="widthLimited" [routeId]="routeId"
            [readonly]="readonly"></shared-route-properties>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'changeMarks'">
        <shared-route-changemarks [routeId]="routeId" class="component" [showtitle]="true" [readonly]="readonly"
            (valueChange)="getData()">
        </shared-route-changemarks>
    </div>

    <div class="detall linkpage" *ngIf="optionExpanded == 'links'">
        <shared-route-links [routeId]="routeId" class="component">
        </shared-route-links>
    </div>

    <div class="detall linkpage" *ngIf="optionExpanded == 'phaseLinks'">
        <shared-route-links [phaseId]="phaseSelected.phaseId" class="component">
        </shared-route-links>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'phaseDocumentation'">
        <shared-documentaryreview-route-item [phaseId]="phaseSelected.phaseId" [routeId]="routeId" [readonly]="readonly">
        </shared-documentaryreview-route-item>
    </div>

    <div class="detall" *ngIf="optionExpanded == 'treeChart'">
        <shared-route-chart [routeId]="routeId" class="component" [showtitle]="true" [readonly]="readonly">
        </shared-route-chart>
    </div>

    <div class="dummy-block">
        <span class="dummy-text">.</span>
    </div>
</div>